<ng-container>
  <lfw-toolbar>
    <lfw-toolbar-text text="{{ caption }}" />
    <span style="flex: 1 1 auto"></span>
    <lfw-toolbar-button
      label="{{ 'DIALOGS.CLOSE' | translate }}"
      icon="close"
      (click)="close($event)"></lfw-toolbar-button>
  </lfw-toolbar>
  @if (blob) {
    <ngx-extended-pdf-viewer
      [src]="blob"
      [showOpenFileButton]="false"
      [showDrawEditor]="false"
      [showTextEditor]="false"
      [showStampEditor]="false"
      [showHighlightEditor]="false"
      [showFindButton]="true"
      [textLayer]="true"></ngx-extended-pdf-viewer>
  }
</ng-container>
